<template>
  <v-row justify="center" align="start">
    <v-col class="pt-10" cols="12" align="center">
      <span class="text-h2 font-weight-bold grey--text text--darken-3" v-html="$t('default')">
      </span>
    </v-col>
    <v-col cols="10" class="py-2 mt-5">
      <v-row class="fill-height mt-3" align="center" justify="center">
        <v-col align="center" :cols="menu.col" v-for="(page, index) in $t('homepages')" :key="index" class="mb-6">
          <v-card @click="goto(page)" class="menuItem d-flex flex-column align-center justify-center"
            :width="menu.width" :height="menu.height" elevation="8" color="primary">
            <v-img :src="page.menuIcon.url" :width="menu.imageWidth" contain>
            </v-img>
            <v-card-text class="text-h5 white--text font-weight-bold pb-0">
              {{ page.menuName }}
            </v-card-text>
            <v-card-text class="text-subtitle-1 white--text pt-0">
              {{ page.desc }}
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <!-- <v-col cols="12">
      <v-divider class="mx-10" color="black"></v-divider>
      <languageBar class="mt-3"></languageBar>
    </v-col> -->
  </v-row>
</template>

<script>
import languageBar from '@/components/languageBar'
import { mapGetters } from 'vuex'

export default {
  name: 'menuMatrix',
  components: {
    languageBar
  },
  data() {
    return {
      menu: {
        height: null,
        width: null,
        col: null,
        imageWidth: null
      }
    }
  },
  computed: {
    ...mapGetters(['getCMSlink', 'getTouchCount', 'isUserLooking'])
  },
  methods: {
    goto(page) {
      if (page.pageType.length !== 0) {
        switch (page.pageType[0].__typename) {
          case 'ComponentHomepageNavigation':
            this.$store.commit("setIsThinking", false)
            this.$store.commit('setRequestQna', false)
            this.$store.commit("setSpeechRecognitionHandler", false);
            this.$router.push('/' + page.pageType[0].pathName.toLowerCase());
            this.$store.commit('setPageHeader', page.pageType[0].pageHeader)
            this.$store.commit('setQnaKeyword', '')

            // To start session using touch - when no face detected
            if (!this.isUserLooking) {
              this.$store.commit('setTouchCount', this.getTouchCount + 1)
              if (this.getTouchCount === 1) {
                // start time
                this.$store.commit('setStartUserSession', new Date())
                this.$store.dispatch('addInteractionToPostgres', { actionType: 'Session Started', actionPayload: { recognitionType: 'Touch' } })
                //session start object
                this.$store.commit('setTouchRequest', {
                  module: 'Default',
                  action: 'Touch Detected',
                  response: 'User Session Started - Touch Detected',
                  timeStamp: new Date(),
                  requestType: 'Session'
                })
              }
            }

            // Will be called irrespective of Touch Count
            this.$store.commit('setTouchRequest', {
              module: 'Home Page',
              action: 'navigate',
              response: page.pageType[0].pathName,
              timeStamp: new Date(),
              requestType: 'Touch'
            })
            this.$store.dispatch('addInteractionToPostgres', { actionType: 'Interaction', actionPayload: { module: 'Home Page', navigateFrom: 'Home Page', navigateTo: page.pageType[0].pathName, interactionType: 'Touch', elementContent: page.pageType[0].pathName } })

            this.$store.commit('setDefaultBubbleText', true)
            this.$store.dispatch('avatarSpeak', page.speech)
            break;
          case 'ComponentHomepageDialogBox':
            console.log('AT open dialog box: ', page.pageType[0].type)
            // To start session using touch - when no face detected
            if (!this.isUserLooking) {
              this.$store.commit('setTouchCount', this.getTouchCount + 1)
              if (this.getTouchCount === 1) {
                // start time
                this.$store.commit('setStartUserSession', new Date())
                this.$store.dispatch('addInteractionToPostgres', { actionType: 'Session Started', actionPayload: { recognitionType: 'Touch' } })
                //session start object
                this.$store.commit('setTouchRequest', {
                  module: 'Default',
                  action: 'Touch Detected',
                  response: 'User Session Started - Touch Detected',
                  timeStamp: new Date(),
                  requestType: 'Session'
                })
              }
            }
            if (page.pageType[0].type === 'url') {
              this.$store.commit('setTouchRequest', {
                module: 'Home Page',
                action: 'navigate',
                response: 'Hearings',
                timeStamp: new Date(),
                requestType: 'Touch'
              })
              this.$store.dispatch('addInteractionToPostgres', { actionType: 'Interaction', actionPayload: { module: 'Home Page', navigateFrom: 'Home Page', navigateTo: 'Hearings', interactionType: 'Touch', elementContent: page.pageType[0].pathName } })
              window.open(page.pageType[0].textList, '_blank')
            }
            break;
          default:
            break;
        }
      }

    },
  },
  mounted() {
    if (this.$i18n.t('homepages').length <= 4) {
      this.menu = {
        height: 280,
        width: 290,
        col: 5,
        imageWidth: "45%"
      }
    } else if (this.$i18n.t('homepages').length <= 6) {
      this.menu = {
        height: 260,
        width: 275,
        col: 4,
        imageWidth: "55%"
      }
    }
  }
}
</script>

<style>
.menuItem {
  border: solid #6b1530 !important;
  border-radius: 20px !important;
  box-shadow: 5px 4px 0 rgb(94, 161, 223) !important;
}

.footer {
  bottom: 0 !important;
}
</style>
<i18n>
    {
      "en": {
          "default": "How Can I Help <br> You Today?"
        },
      "es":{
          "default": "¿Le puedo ayudar en algo?"
        }
    }
  </i18n>